import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

const AVP_DASHBOARD_CLIENT_ID_PREFIX = 'avp-dashboard';

export const getAvpDashboardClientId = (dashboardAri: string): ClientId =>
	client(`${AVP_DASHBOARD_CLIENT_ID_PREFIX}-${dashboardAri}`);
